import React, { useState } from 'react';
import { setJasperIframeOpen } from '../features/jasperIframe/jasperIframeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useGetJasperMutation } from '../api/jasper';
import store, { RootState } from '../store';
import RightArrowIcon from '../assets/images/arrow_right_alt.svg';
interface JasperCardProps {
    title: string;
    className: string;
    cover: string;
    assessmentCount?: number;
    worksheetCount?: number;
    hasAssessments?: boolean;
    isSupported?: boolean;
    supportMessage?: string;
    onClick?: () => void;
    isCreated?: boolean;

    isLocked: boolean;
    book_url: string;
    series: string;
    book_id: any;
}

const JasperCard: React.FC<JasperCardProps> = ({
    title,
    className,
    cover,
    assessmentCount = 0,
    worksheetCount = 0,
    hasAssessments = false,
    isSupported = true,
    supportMessage = 'Jasper not supported!',
    onClick,
    isCreated = false,
    book_id,
}) => {
    const dispatch = useDispatch();
    const product = useSelector((state: RootState) => state.product);
    const school_id = store.getState().SchoolInfo.data.school.id;
    const [getJasper, { isLoading: jasperApiLoading, isError, data }] =
        useGetJasperMutation();
    const handleJasperRoute = () => {
        getJasper({
            product_type: product,
            book_id: book_id,
            school_id: school_id,
        })
            .then((response) => {
                dispatch(
                    setJasperIframeOpen({
                        isOpen: true,
                        url: response.data.data.url,
                    })
                );
            })
            .catch((error: any) => {
                console.error('Error fetching jasper data', error);
            });
    };

    return (
        <div
            className={`
                flex items-start justify-start
                bg-white rounded-2xl min-h-[7.75rem] border p-4 border-gray-200 shadow-sm hover:shadow-md transtion-all duration-200 cursor-pointer
                ${!isSupported ? 'opacity-75' : 'hover:border-blue-300'}
                `}
            onClick={() => handleJasperRoute()}
        >
            {/* Header with class info */}
            {/* <div className="flex items-center justify-between mb-3">
                <span className="text-sm text-gray-600 font-medium">
                    {className}
                </span>
            </div> */}

            {/* Book cover and content */}
            <div className="flex gap-3 w-full h-full">
                {/* Book cover */}
                <div className="flex-shrink-0">
                    <img
                        src={cover}
                        alt={title}
                        className="w-28 h-36 object-cover rounded-lg shadow-sm"
                    />
                </div>

                {/* Content */}
                <div className="flex-col w-full h-full ml-2 justify-between items-end">
                    <div className="flex-col w-auto h-[70%]">
                        <h3 className="text-lg font-semibold text-[#666666] line-clamp-2">
                            {className.replace(/([a-zA-Z])(\d)/, '$1 $2')}
                        </h3>
                        <h3 className="text-xl font-semibold text-[#222222] mb-2 line-clamp-2 text-wrap">
                            {title}
                        </h3>
                    </div>

                    {/* Status/Content based on card state */}
                    <div className=" flex w-full h-[30%] justify-end">
                        {/* <div className="text-red-500 text-xs font-medium">
                            Jasper not supported!
                        </div> */}

                        <div className="w-6 h-6 flex ">
                            <img src={RightArrowIcon} alt="RightArrowIcon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(JasperCard);
